import * as actionTypes from "./actionTypes";

export const addPhysicalInventoryAction = (physicalInventoryData) => {
  return { type: actionTypes.ADD_PHYSICAL_INVENTORY, physicalInventoryData };
};

export const addPhysicalInventorySuccessAction = (captureGoodsResponse) => {
  return {
    type: actionTypes.ADD_PHYSICAL_INVENTORY_SUCCESS,
    captureGoodsResponse,
  };
};

export const addPhysicalInventoryManualRxAction = (physicalInventoryData) => {
  return {
    type: actionTypes.ADD_PHYSICAL_INVENTORY_MANUAL_RX,
    physicalInventoryData,
  };
};

export const addPhysicalInventoryManualRxWitoutLotNoAction = (
  physicalInventoryData
) => {
  return {
    type: actionTypes.ADD_PHYSICAL_INVENTORY_MANUAL_RX_WITHOUT_LOT_NO,
    physicalInventoryData,
  };
};

export const addPhysicalInventoryManualRxSuccessAction = (
  physicalInventoryData
) => {
  return {
    type: actionTypes.ADD_PHYSICAL_INVENTORY_MANUAL_RX_SUCCESS,
    physicalInventoryData,
  };
};

export const addPhysicalInventoryOtcAction = (addOtcProductData) => {
  return { type: actionTypes.ADD_PHYSICAL_INVENTORY_OTC, addOtcProductData };
};

export const addPhysicalInventoryOtcSuccessAction = (captureGoodsResponse) => {
  return {
    type: actionTypes.ADD_PHYSICAL_INVENTORY_OTC_SUCCESS,
    captureGoodsResponse,
  };
};

export const addPhysicalInventoryRxOtcWithoutLotNoAction = (
  addOtcProductData
) => {
  return {
    type: actionTypes.ADD_PHYSICAL_INVENTORY_OTC_RX_WITHOUT_LOT_NO,
    addOtcProductData,
  };
};

export const addPhysicalInventoryRxOtcWithoutLotNoSuccessAction = (
  captureGoodsResponse
) => {
  return {
    type: actionTypes.ADD_PHYSICAL_INVENTORY_OTC_RX_WITHOUT_LOT_NO_SUCCESS,
    captureGoodsResponse,
  };
};

export const addPhysicalInventoryRxAction = (addOtcProductData) => {
  return { type: actionTypes.ADD_PHYSICAL_INVENTORY_RX, addOtcProductData };
};

export const addPhysicalInventoryRxSuccessAction = (captureGoodsResponse) => {
  return {
    type: actionTypes.ADD_PHYSICAL_INVENTORY_RX_SUCCESS,
    captureGoodsResponse,
  };
};

export const addOtcProductAction = (addOtcProductData) => {
  return { type: actionTypes.ADD_OTC_PRODUCT, addOtcProductData };
};

export const addOtcProductSuccessAction = (captureGoodsResponse) => {
  return { type: actionTypes.ADD_OTC_PRODUCT_SUCCESS, captureGoodsResponse };
};

export const addRxProductAction = (addRxProductData) => {
  return { type: actionTypes.ADD_RX_PRODUCT, addRxProductData };
};

export const addRxProductSuccessAction = (captureGoodsResponse) => {
  return { type: actionTypes.ADD_RX_PRODUCT_SUCCESS, captureGoodsResponse };
};

export const addOtcManualProductAction = (addOtcManualProductData) => {
  return { type: actionTypes.ADD_OTC_MANUAL_PRODUCT, addOtcManualProductData };
};

export const addOtcManualProductSuccessAction = (captureGoodsResponse) => {
  return {
    type: actionTypes.ADD_OTC_MANUAL_PRODUCT_SUCCESS,
    captureGoodsResponse,
  };
};
